import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import DataRow from './DataRow'
import DynamicFields from 'src/component/DynamicFields/DynmicFields'
import { Localizer } from 'src/common/constants'
import { defaultItem } from '.'
import { DecisionMedicineType } from 'src/types/Requests/MobDecisionMedicines'
import { RepeatedDosesType } from 'src/types/DoctorScreens/DoctorOrders'
import { PharmacyMedicineType } from 'src/types/Requests/MobShared/HospitalMedicines'

interface IDynamisServiceCard {
  data: any,
  setData: Dispatch<SetStateAction<any>>,
  medicinesList: PharmacyMedicineType[]
  decisionMedicinesList: DecisionMedicineType[]
  decisionId: number | null
  hospitalId: number | null
  isResritctMedicineAllDecisionPeriod?: boolean
  setNotAvailableMap: Dispatch<SetStateAction<Record<number, boolean>>>
}

export const RepeatedDoses = Localizer<RepeatedDosesType>([
  { label: "daily", repeat: 30, value: 1, allowsAllDurations: false },
  { label: "weekly", repeat: 4, value: 7, allowsAllDurations: false },
  { label: "monthly", repeat: 1, value: 30, allowsAllDurations: false },
  { label: "all-duration", value: 4, isAll: true, allowsAllDurations: true },
])

export const userDose = Localizer([
  { label: "daily", value: 1 },
  { label: "daily-by-day", value: 2 },
  { label: "twice-a-week", value: 3 },
  { label: "once-a-week", value: 4 },
  { label: "once-a-month", value: 5 },
])

const DynamisServiceCard: FC<IDynamisServiceCard> = ({
  setData,
  hospitalId,
  medicinesList,
  data,
  decisionMedicinesList,
  decisionId,
  isResritctMedicineAllDecisionPeriod,
  setNotAvailableMap
}) => {

  useEffect(() => {
    if (!decisionMedicinesList?.length || !medicinesList?.length) return

    const mappedData = decisionMedicinesList.map((item: DecisionMedicineType) => ({
      sMedicine: medicinesList.find(m => m.value === item.medicineId) || null,

      allowsAllDurations: item?.allowsAllDurations ?? false,

      duration: item?.duration || 1,
      durationType: item?.allowsAllDurations
        ? RepeatedDoses.find(d => d.allowsAllDurations == item?.allowsAllDurations)
        : RepeatedDoses.find(d => d.value == item?.durationType)
        ?? (isResritctMedicineAllDecisionPeriod
          ? RepeatedDoses[3]
          : RepeatedDoses[2]),

      directAmount: item?.directAmount || "",

      sDoseType: userDose.find(d => d.value == item?.doseTypeId) || userDose[0],

      dosePerDay: item?.dosePerDay || 1,

      doseCountPerTime: item?.doseCountPerTime || 1,
    }))
    setData(mappedData)

  }, [decisionMedicinesList, medicinesList, isResritctMedicineAllDecisionPeriod])

  return (
    <DynamicFields
      defaultItems={[defaultItem]}
      listData={data}
      setListData={setData}
      addBtnTitle='add-new-medicine'
      renderItem={(item: any, index: number) => {
        return (
          <DataRow
            rowItem={item}
            setData={setData}
            data={data}
            index={index}
            decisionId={decisionId}
            hospitalId={hospitalId}
            medicinesList={medicinesList}
            setNotAvailableMap={setNotAvailableMap}
            isResritctMedicineAllDecisionPeriod={isResritctMedicineAllDecisionPeriod}
          />
        )
      }}
    >

    </DynamicFields >
  )

}


export default DynamisServiceCard